// OK 25/10/2024

import { ip } from "../utils/setup";
import { Empl } from "../interfaces";
import { ObjectId } from "../types";

const EMPL_API = `${ip}/api/Empls`;

// GET

export async function getEmplStaff(): Promise<Empl[]> {
    const response = await fetch(EMPL_API, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(
      `Connexion au serveur impossible, code serveur: ${response.status}`
    );
  }
}

export async function getEmplStaffNoHiden() {
  try {
      const response = await fetch(EMPL_API + "/noHiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

export async function getEmplStaffHiden() {
  try {
      const response = await fetch(EMPL_API + "/Hiden", {
          credentials: "include" 
      });
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    }
  } catch (e: any) {
    throw new Error(e.message);
  }
}

// GET ID

export async function getEmpl(_id: ObjectId): Promise<Empl> {
    const response = await fetch(`${EMPL_API}/${_id}`, {
        credentials: "include" 
    });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error("Erreur du serveur lors de la récetpion de l'employeur");
  }
}

// POST

export async function createEmpl(newEmpl: Partial<Empl>): Promise<Empl> {
  const response = await fetch(EMPL_API, {
      method: "POST",
      credentials: "include" ,
    headers: {
        "content-type": "application/json",
        
    },
    body: JSON.stringify(newEmpl),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error(" Erreur lors de la création du nouvel employeur");
  }
}

//PUT

export async function updateEmpl(updateEmpl: Empl) {
  const { globalError, ...restEmpl } = updateEmpl;
  const response = await fetch(`${EMPL_API}/${restEmpl.idEmpl}`, {
      method: "PUT",
      credentials: "include" ,
      headers: {
          "Content-Type": "application/json",
          
      },
    body: JSON.stringify(restEmpl),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition de l'employeur");
  }
}

// DELETE

export async function deleteEmpl(_id: ObjectId): Promise<ObjectId> {
  const response = await fetch(`${EMPL_API}/${_id}`, {
      method: "DELETE",
      credentials: "include" ,
      
  });
  if (response.ok) {
    return _id;
  } else {
    throw new Error(" Erreur lors de la suppression de l'employeur");
  }
}
